import { MessageChat, ItemMessageChat } from '@/types/itemsMessages'

export const formatMessage = (message: string): string => {
  let text = message
  const content = message.split('\n')

  if (content[2] !== undefined) {
    content[2] = ` ${content[2]}`
    text = content.join('\n')
  }

  text = ' ' + text
  return text.replaceAll(/(?: \*)(?:(?!\s))((?:(?!\*|\n).)+)(?:\*)/g, ' <strong>$1</strong>')
    .replaceAll(/(?: _)(?:(?!\s))((?:(?!\n|_).)+)(?:_)/g, ' <italic>$1</italic>')
    .replaceAll(/(?: ~)(?:(?!\s))((?:(?!\n|~).)+)(?:~)/g, ' <s>$1</s>')
    .replaceAll(/(?: --)(?:(?!\s))((?:(?!\n|--).)+)(?:--)/g, ' <u>$1</u>')
    .replaceAll(/(?: ```)(?:(?!\s))((?:(?!\n|```).)+)(?:```)/g, ' <code>$1</code>')
    .replaceAll(/(?: )(https?:\/\/[^\s]+)/g, ' <a href="$1" target="_blank" rel="noopener noreferrer">$1</a>')
    .replaceAll(/\n/g, '<br>')
    .trim()
}

export function mountLastMessage (message : MessageChat) {
      let legend : string | null | undefined  = null
      if (message?.extra?.multimedia?.legend) {
        legend = message.extra.multimedia.legend
      }
      const last = {
        text: message.content,
        image: legend ?? 'Imagem',
        audio: 'Audio',
        video: legend ?? 'Video',
        file: legend ?? 'Arquivo',
        document: legend ?? 'Documento',
        system: 'Mensagem do sistema',
        default: 'Mensagem',
        none: legend ?? 'Arquivo'
      }
      return last[message.type] ?? ''
}

export function orderIdDesc( data : ItemMessageChat[]) : ItemMessageChat[] {
    return data.sort(function ( a, b ) {
        if (a?.id && b?.id) {
            if (a.id > b.id) return 1
            if (a.id < b.id) return -1
        }
        return 0
    })
}
export function orderDateAsc( data : ItemMessageChat[]) : ItemMessageChat[] {
    return data.sort(function ( a, b ) {
        if (a?.created_at && b?.created_at) {
            if (a.created_at < b.created_at) return 1
            if (a.created_at > b.created_at) return -1
        }
        return 0
    })
}
